import { colors as appColors, icons as appIcons, themes as appThemes } from '@convatec/180medical-website/app/themes'

export default defineAppConfig({
  ui: {
    icons: {
      ...appIcons,
    },
    ...appThemes,
    colors: appColors,
  },
})
